import { createFileRoute } from "@tanstack/react-router";
import { CertificacaoLP } from "@/components/certificacao/CertificacaoLP";
import { CERT_META } from "@/lib/certificacao/config";
import { CERT_DATA } from "@/lib/certificacao/data";

/** Grupo de WhatsApp exclusivo da segunda LP (separado da principal). */
const QUADRIL_GRUPO_WPP_LP2 = "https://chat.whatsapp.com/JErUWZwZB6PKt5CPIx9tRX";

const m = CERT_META.quadril;
const SITE = "https://fisioemortopedia.com.br";

export const Route = createFileRoute("/certificacao-quadril2")({
  head: () => ({
    meta: [
      { title: `${m.seoTitle} · Grupo` },
      { name: "description", content: m.seoDescription },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: `${m.seoTitle} · Grupo` },
      { property: "og:description", content: m.seoDescription },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: `${SITE}${m.path}` },
      // LCP: fundo do topo baixado com prioridade máxima.
      ...(CERT_DATA.quadril.heroBg
        ? [
            {
              rel: "preload",
              as: "image",
              href: CERT_DATA.quadril.heroBg,
              fetchPriority: "high" as const,
            },
          ]
        : []),
    ],
  }),
  component: () => <CertificacaoLP slug="quadril" mode="captura" directUrl={QUADRIL_GRUPO_WPP_LP2} />,
});
